import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51db1db3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-cell" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-sub" }
const _hoisted_4 = { class: "cm-align-center gap-x-10" }

import { ref, reactive, computed, onMounted, PropType } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage, ElMessageBox } from 'element-plus'
import CmTable from '@/components/cmTable/index.vue'
import { TableOpt } from '@/components/cmTable/types'
import {
  TableViewMode,
  TableViewModeType,
  TABLE_PREVIEW_PAGE_SIZE,
  TABLE_FULL_PAGE_SIZE_DEFAULT
} from '@/views/dashboard/_enum/table-view-mode'
import { BaseLineService, BaselineCheckItemStatRow } from '@/views/dashboard/safe-status/base-line/base-line.service'
import {
  ensureBaselineRepairItemsLoaded,
  getBaselineCheckItemLabelsById,
  resolveCheckItemNonComplianceCount,
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'
import { listCol } from '@/utils/list-columns-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseline-ignored-table',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 为 true 时预览模式下不展示筛选栏右侧按钮（由外层 Card headerRight 承载） */
  suppressToolbarActions: {
    type: Boolean,
    default: false
  }
},
  emits: ["viewAll", "detail", "refresh"],
  setup(__props, { expose: __expose, emit: __emit }) {

function formatIgnoredDetectionItem (row: BaselineCheckItemStatRow) {
  void locale.value
  const c = getBaselineCheckItemLabelsById(row.check_item_id)
  return {
    title: c.itemName || row.item_name || row.check_item_id || '--',
    category: c.categoryName || row.category_name || '',
  }
}

const props = __props



const emit = __emit

const injector = useReflectiveInjector([BaseLineService])
const service = injector.get(BaseLineService)
const tableRef = ref<any>(null)
const { refreshList } = useCmTableListRefresh(tableRef)
const { t, locale } = useI18n()

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }
const form = reactive({})
const multipleSelection = ref<BaselineCheckItemStatRow[]>([])
const selectionIds = computed(() => multipleSelection.value.map(r => r.check_item_id))

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    selection: true,
    columns: [
      {
        prop: 'item_display',
        label: t('baselineDashboard.detectionItem'),
        slotName: 'item_display',
        columnOpt: { minWidth: 220 },
        showOverflow: true
      },
      {
        prop: 'non_compliance_count',
        label: t('baselineDashboard.nonCompliantTerminals'),
        columnOpt: { minWidth: 120 }
      },
      {
        prop: 'operation',
        label: listCol(t, 'operation'),
        slotName: 'operation',
        width: 230,
        columnOpt: {  fixed: 'right' }
      }
    ],
    usePagination: false,
    showSearch: false,
    showForm: false,
    showActionBar: false,
    showRightToolbar: true,
    rowKey: 'check_item_id',
    path: 'data',
    totalPath: 'total',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    hiddenPageTool: props.viewMode === TableViewMode.preview,
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined
  }
})

async function getListApi (params: Record<string, unknown>) {
  const isPreview = props.viewMode === TableViewMode.preview
  const page = isPreview ? 1 : (Number(params.page) || 1)
  const limit = isPreview ? TABLE_PREVIEW_PAGE_SIZE : (Number(params.limit) || TABLE_FULL_PAGE_SIZE_DEFAULT)
  try {
    return await service.getIgnoredCheckItemList({
      page,
      limit
    })
  } catch {
    return { list: [] as BaselineCheckItemStatRow[], total: 0 }
  }
}

async function handleQuery () {
  await refreshList()
}

function handleReset () {
  void refreshList()
}

function handleSelectionChange (rows: BaselineCheckItemStatRow[]) {
  multipleSelection.value = rows
}

async function cancelRows (ids: string[]) {
  if (!ids.length) return
  const message = ids.length === 1
    ? t('baselineDashboard.confirmCancelIgnoreSingle')
    : t('baselineDashboard.confirmCancelIgnoreBatch', { count: ids.length })
  try {
    await ElMessageBox.confirm(message, t('cmtable.tip'), {
      type: 'warning',
      confirmButtonText: t('cmtable.confirm'),
      cancelButtonText: t('common.cancel')
    })
  } catch {
    return
  }
  try {
    await service.cancelIgnoreCheckItems({ check_item_ids: ids })
    ElMessage.success(t('baselineDashboard.cancelIgnoreSuccess'))
    tableRef.value?.tableRef?.clearSelection()
    multipleSelection.value = []
    void refreshList()
    emit('refresh')
  } catch {
    ElMessage.error(t('baselineDashboard.cancelIgnoreFail'))
  }
}

function cancelOne (row: BaselineCheckItemStatRow) {
  cancelRows([row.check_item_id])
}

function onBatchCancelIgnore () {
  cancelRows(selectionIds.value)
}

const selectedCount = computed(() => selectionIds.value.length)

onMounted(async () => {
  await ensureBaselineRepairItemsLoaded(() => service.getAllBaselineItems())
})

__expose({
  getList: () => void refreshList(),
  batchCancelIgnore: onBatchCancelIgnore,
  selectedCount,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: form,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
    "table-opt": tableOpt.value,
    api: getListApi,
    "page-option": pageOption,
    "first-loading": true,
    onChangeSelected: handleSelectionChange
  }, {
    header: _withCtx(() => [
      (__props.viewMode === _unref(TableViewMode).full)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "small",
            disabled: !selectionIds.value.length,
            onClick: onBatchCancelIgnore,
            class: "cm-ui-mb16"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('baselineDashboard.cancelIgnore')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    item_display: _withCtx(({ row }: any) => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([formatIgnoredDetectionItem(row as BaselineCheckItemStatRow)], (d) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: (row as BaselineCheckItemStatRow).check_item_id
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(d.title), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(d.category), 1)
          ], 64))
        }), 128))
      ])
    ]),
    operation: _withCtx(({ row }: any) => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "text",
          size: "small",
          onClick: ($event: any) => (cancelOne(row as BaselineCheckItemStatRow))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('baselineDashboard.cancelIgnore')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "text",
          size: "small",
          onClick: ($event: any) => (emit('detail', row as BaselineCheckItemStatRow))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(listCol)(_unref(t), 'detail')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})